/* Gift finder (sections/gift-finder.liquid): ranks the in-stock products of the interest collections by
   recipient, occasion, budget and interest. Everything happens in the page; the URL never changes. */
(function () {
  'use strict';
  var PAGE = 8;

  function weights(s) {
    var o = {};
    String(s || '').split(',').forEach(function (part) {
      var a = part.split(':');
      var k = (a[0] || '').trim();
      if (k) o[k] = a.length > 1 ? parseFloat(a[1]) || 0 : 1;
    });
    return o;
  }

  function best(w, m) {
    var top = 0;
    for (var k in m.k) if (w[k] > top) top = w[k];
    return top;
  }

  function init(root) {
    var el = root.querySelector('[data-gf-data]');
    if (!el) return;
    var d;
    try { d = JSON.parse(el.textContent); } catch (e) { return; }
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    var byId = {}, list = [];
    // One entry per product and interest; "set" entries only mark gift sets (products without data are skipped).
    (d.p || []).forEach(function (x) {
      if (!x.h) return;
      var m = byId[x.h] || (byId[x.h] = { k: {}, s: false });
      if (x.t && !m.t) { m.t = x.t; m.u = x.u; m.i = x.i; m.p = x.p; m.f = x.f; m.c = x.c; list.push(m); }
      if (x.k === 'set') m.s = true; else if (x.k) m.k[x.k] = 1;
    });

    var who = {}, occ = {}, bud = d.budget || {}, love = d.love || {};
    for (var k1 in d.who) if (k1) who[k1] = weights(d.who[k1]);
    for (var k2 in d.occasion) if (k2) occ[k2] = { w: weights(d.occasion[k2].w), min: d.occasion[k2].min, max: d.occasion[k2].max, sets: d.occasion[k2].sets, corp: d.occasion[k2].corp };

    var state = { who: '', occasion: '', budget: '', love: '' };
    String(d.preset || '').split('&').forEach(function (kv) {
      var a = kv.split('=');
      if (a[0] in state && a[1]) state[a[0]] = a[1];
    });
    Object.keys(state).forEach(function (g) {
      if (!state[g]) return;
      var input = root.querySelector('input[name="gf-' + g + '"][value="' + state[g] + '"]');
      if (input) input.checked = true; else state[g] = '';
    });

    var resultsEl = root.querySelector('[data-gf-results]');
    var countEl = root.querySelector('[data-gf-count]');
    var moreEl = root.querySelector('[data-gf-more]');
    var corpEl = root.querySelector('[data-gf-corporate]');
    var shown = PAGE, ranked = [];

    // Budget limits in the visitor's currency, rounded to amounts people use (30 € → 350 kr, 200 € → 2 300 kr).
    function nice(v) {
      if (rate === 1) return v;
      var step = v >= 5000 ? 500 : v >= 1000 ? 100 : v >= 100 ? 50 : 10;
      return Math.round(v / step) * step;
    }
    function cents(eur) { return nice(eur * rate) * 100; }
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }); } catch (e) { fmt = null; }
    function money(eur) { var v = nice(eur * rate); return fmt ? fmt.format(v) : v + ' ' + cur; }
    function range(a, b) {
      var x = nice(a * rate), y = nice(b * rate);
      try { if (fmt && fmt.formatRange) return fmt.formatRange(x, y); } catch (e) { /* older browsers */ }
      return money(a) + '–' + money(b);
    }
    root.querySelectorAll('[data-gf-budget]').forEach(function (chip) {
      var b = bud[chip.getAttribute('data-gf-budget')];
      if (!b) return;
      chip.textContent = !b.min ? String(d.upto || '').replace('[x]', money(b.max))
        : !b.max ? String(d.over || '').replace('[x]', money(b.min))
        : range(b.min, b.max);
    });

    function inBudget(m, b) {
      if (!b) return true;
      return m.p >= cents(b.min || 0) && (!b.max || m.p <= cents(b.max));
    }

    function score(m) {
      var s = m.s ? 0.5 : 0;
      if (state.who && who[state.who]) s += 3 * best(who[state.who], m);
      var o = state.occasion && occ[state.occasion];
      if (o) {
        s += 2 * best(o.w, m);
        if (o.sets && m.s) s += 2;
        if (o.min && m.p < cents(o.min)) s -= 3;
        if (o.max && m.p > cents(o.max)) s -= 3;
      }
      if (state.love && m.k[state.love]) s += 6;
      if (!state.budget && m.p < cents(15)) s -= 0.5;
      return s;
    }

    // The interest a product stands for in the current choice (the most weighted one), for variety.
    function primary(m) {
      var w = {}, k, top = -1, key = '';
      if (state.who && who[state.who]) for (k in who[state.who]) w[k] = (w[k] || 0) + 3 * who[state.who][k];
      var o = state.occasion && occ[state.occasion];
      if (o) for (k in o.w) w[k] = (w[k] || 0) + 2 * o.w[k];
      for (k in m.k) if ((w[k] || 0) > top) { top = w[k] || 0; key = k; }
      return key;
    }

    function rank() {
      var b = state.budget && bud[state.budget];
      var relaxed = false;
      var pool = list.filter(function (m) { return (!state.love || m.k[state.love]) && inBudget(m, b); });
      if (!pool.length) {
        relaxed = true;
        pool = list.filter(function (m) { return !state.love || m.k[state.love]; });
        if (!pool.length) pool = list.slice();
      }
      // Equal scores: closest to the budget, or to a typical gift price (90 €) when no budget is chosen.
      var target = b ? cents(b.max ? b.max * 0.75 : (b.min || 0) * 1.3) : cents(90);
      var sorted = pool.map(function (m) { return { m: m, s: score(m), k: primary(m) }; }).sort(function (x, y) {
        if (y.s !== x.s) return y.s - x.s;
        return Math.abs(x.m.p - target) - Math.abs(y.m.p - target);
      });
      if (state.love) { ranked = sorted.map(function (r) { return r.m; }); return relaxed; }
      // Variety: each further product of an interest already shown counts a little less, so knives, grill,
      // coffee and table gifts take turns instead of one interest filling the first rows.
      ranked = [];
      var used = {};
      while (sorted.length) {
        var bi = 0, bv = -Infinity;
        for (var i = 0; i < sorted.length && i < 60; i++) {
          var v = sorted[i].s - 1.2 * (used[sorted[i].k] || 0);
          if (v > bv) { bv = v; bi = i; }
        }
        var r = sorted.splice(bi, 1)[0];
        used[r.k] = (used[r.k] || 0) + 1;
        ranked.push(r.m);
      }
      return relaxed;
    }

    function why(m) {
      var out = [];
      var key = state.love && m.k[state.love] ? state.love : null;
      if (!key) {
        var w = (state.who && who[state.who]) || (state.occasion && occ[state.occasion] && occ[state.occasion].w) || {};
        var top = 0;
        for (var k in m.k) if ((w[k] || 0) > top && love[k]) { top = w[k]; key = k; }
        if (!key) for (var k3 in m.k) { if (love[k3]) { key = k3; break; } }
      }
      if (key && love[key]) out.push(love[key]);
      if (m.s && d.set) out.push(d.set);
      return out.join(' · ');
    }

    function card(m) {
      var li = document.createElement('li');
      var art = document.createElement('article');
      art.className = 'card';
      var media = document.createElement('div');
      media.className = 'card__media';
      if (m.i) {
        var img = document.createElement('img');
        img.src = m.i; img.alt = m.t; img.loading = 'lazy'; img.width = 480; img.height = 480;
        media.appendChild(img);
      }
      var body = document.createElement('div');
      body.className = 'card__body';
      var reason = why(m);
      if (reason) { var meta = document.createElement('p'); meta.className = 'card__meta'; meta.textContent = reason; body.appendChild(meta); }
      var h = document.createElement('h3');
      h.className = 'card__title';
      var a = document.createElement('a');
      a.className = 'card__link'; a.href = m.u; a.textContent = m.t;
      h.appendChild(a); body.appendChild(h);
      var price = document.createElement('p');
      price.className = 'price' + (m.c ? ' price--sale' : '');
      var cur = document.createElement('span'); cur.className = 'price__current'; cur.textContent = m.f; price.appendChild(cur);
      if (m.c) { var was = document.createElement('s'); was.className = 'price__compare'; was.textContent = m.c; price.appendChild(document.createTextNode(' ')); price.appendChild(was); }
      body.appendChild(price);
      art.appendChild(media); art.appendChild(body); li.appendChild(art);
      return li;
    }

    function render(rerank) {
      var relaxed = false;
      if (rerank) { relaxed = rank(); shown = PAGE; }
      resultsEl.textContent = '';
      ranked.slice(0, shown).forEach(function (m) { resultsEl.appendChild(card(m)); });
      moreEl.hidden = shown >= ranked.length;
      if (rerank) countEl.textContent = relaxed ? d.relaxed : String(d.count || '').replace('[count]', ranked.length);
      var o = state.occasion && occ[state.occasion];
      if (corpEl) corpEl.hidden = !(o && o.corp);
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.name || t.name.indexOf('gf-') !== 0) return;
      state[t.name.slice(3)] = t.value;
      render(true);
    });
    moreEl.addEventListener('click', function () { shown += PAGE; render(false); });
    render(true);
  }

  function start() { document.querySelectorAll('[data-gf]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
